import { AxiosCadastro, Axios } from "../../service/serviceBasic";
import { toast } from "react-toastify";
import {
  ADD_ASSOCIADO,
  REMOVE_ASSOCIADO,
  TOGGLE_DONE_ASSOCIADO,
  UPDATE_ASSOCIADO
} from './types';
import tiposSocio from '../../helper/tiposSocio';

export const verifyClientExistsByCpf = (Cpf) =>
  AxiosCadastro.post("v1/basico/pessoa/getpessoa", { Cpf })
    .then(({ data }) => {
      if (!data || !data.IdPessoa) {
        toast.warn("Cliente não encontrado, será necessário cadastrá-lo.", {
          position: toast.POSITION.BOTTOM_RIGHT,
          className: "ui-alert-toast",
        });
        return Promise.reject();
      }
      return { Nome: data.Nome, IdCliente: data.IdPessoa };
    });

export const uploadDocumento = (obj) =>
  Axios.post("v1/cliente/documentoarquivo/upload", obj)
    .then(({ data }) => data)
    .catch((error) => "Seu documento não foi enviado. Tente novamente." );

export const addAssociadoAction = (data) => (dispatch, getState) => {
  const associadoExists = getState().associadoPJReducer
    .some((a) => 
    data.idSocio ?
      a.tipoSocio === data.tipoSocio && a.idSocio === data.idSocio :
      a.tipoSocio === data.tipoSocio
    );
  if (associadoExists) return;
  const associado = data;
  associado.done = false;
  dispatch({
    type: ADD_ASSOCIADO,
    payload: associado,
  });
};

export const removeAssociadoAction = (tipoSocio, idSocio) => (dispatch, getState) => {
  const {
    associadoPJReducer,
    documentosAnexosReducer,
  } = getState();
  const {
    documentos_documentosAdministradorFlag,
    documentosSocioDezOuMais,
    documentosSocioMenosDez,
    documentos_documentosProcuradorFalg,
  } = documentosAnexosReducer;

  const avoidRemove = (() => {
    switch (tipoSocio) {
      case tiposSocio.administrador:
        return documentos_documentosAdministradorFlag;
      case tiposSocio.socioPFDezMais:
        return documentosSocioDezOuMais.some((d) => d.id === idSocio);
      case tiposSocio.socioPFMenosDez:
        return documentosSocioMenosDez.some((d) => d.id === idSocio);
      case tiposSocio.procurador:
        return documentos_documentosProcuradorFalg;
      default: return true;
    }
  })();

  if (avoidRemove) return;

  const associados = associadoPJReducer.filter((a) => 
      a.tipoSocio !== tipoSocio || a.idSocio !== idSocio
    );
  dispatch({
    type: REMOVE_ASSOCIADO,
    payload: associados,
  });
};

export const toggleDoneAssociadoAction = (tipoSocio, idSocio, done) => (dispatch, getState) => {
  const associados = getState().associadoPJReducer;
  const associadoIndex = associados
    .findIndex((a) => a.tipoSocio === tipoSocio && a.idSocio === idSocio);
  if (associadoIndex === -1) return;
  associados[associadoIndex].done = done;

  dispatch({
    type: TOGGLE_DONE_ASSOCIADO,
    payload: associados,
  });
};

export const updateAssociadoAction = (data) => (dispatch, getState) => {
  const associados = getState().associadoPJReducer
    .filter((a) => 
      a.tipoSocio !== data.tipoSocio || a.idSocio !== data.idSocio
    );
  const associado = data;
  associado.done = true;
  dispatch({
    type: UPDATE_ASSOCIADO,
    payload: [...associados, associado],
  });
};

export const warnFormIncompleteAction = (tipoSocio) => (dispatch) => {
  const nomeAssociado = (() => {
    switch (tipoSocio) {
      case 1: return 'administrador';
      case 2: return 'procurador';
      case 3: return 'sócio com < 10% de participação';
      case 4: return 'sócio com >= 10% de participação';
      default: return 'associado';
    }
  })()
  toast.warn(`O formulário de ${nomeAssociado} está incompleto.`, {
    position: toast.POSITION.BOTTOM_RIGHT,
    className: "ui-alert-toast",
  });
};
